<div>
  @if (!isLightTester) {
    <div class="social-sharing-pop">
      <i tabindex="0"
        role="button"
        class="icon-x-material"
        aria-label="Share on X"
        [attr.href]="getTwitterUrl()"
      (click)="openUrl(getTwitterUrl())"></i>
      <i tabindex="0"
        role="button"
        class="icon-linkedin-material"
        aria-label="Share on LinkedIn"
        [attr.href]="getLinkedInUrl()"
      (click)="openUrl(getLinkedInUrl())"></i>
    </div>
  }
  @if (isLightTester) {
    <div class="social-sharing-pop">
      <i tabindex="0"
        role="button"
        class="icon-x-material"
        aria-label="Share on X"
      (click)="checkLightTester($event)"></i>
      <i tabindex="0"
        role="button"
        class="icon-linkedin-material"
        aria-label="Share on LinkedIn"
      (click)="checkLightTester($event)"></i>
    </div>
  }
</div>

